import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import '@/styles/pages.css';

export default function AgentRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <span>Loading...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.plan === 'waitlist') {
    return <Navigate to="/waitlist" replace />;
  }

  return <>{children}</>;
}
